// extracted by mini-css-extract-plugin
export default {"rejectPopup":"RejectAccountRequestPopup_rejectPopup__6hYOa","rejectButton":"RejectAccountRequestPopup_rejectButton__glmLH"};